export namespace API {
    export type OrderDirection = 'desc' | 'asc';

    export interface FilterQuery<TType = any> {
        [key: string]: TType;
    }

    export interface SortingQuery {
        orderBy?: string;
        orderDirection?: OrderDirection;
    }

    export type RequestQuery = SortingQuery & FilterQuery;

    export interface SortingValue {
        sorting: string;
        descending: boolean;
    }

    export type PaginationResult<TEntity> = {
        Page: TEntity[];
        ItemsCount: number;
        PageSize: number;
        PageNumber: number;
    }
}

export const mapSortingToApi =
    ({ sorting, descending }: API.SortingValue): API.SortingQuery => ({
        ...sorting && {
            orderBy: sorting,
            orderDirection: descending ? 'desc' : 'asc',
        },
    });
